import axios from "./AxiosService";

export function getFastTrackAppointments(membershipNumber) {
  return axios
    .get("appointments", {
      params: { membershipNumber: membershipNumber }
    })
    .then(response => {
      return response.data;
    })
    .catch(error => {
      return error && error.response && error.response.data;
    });
}
